import {BaseContainerModel} from '../base-container.model';
import {bl_fi_comp_gendoc_flow_config_RowClass, bl_fi_comp_gendoc_flow_config_RowInterface} from '../../dbschema/bl_fi_comp_gendoc_flow_config.model';
  
  export class CompanyGenDocFlowConfigContainerModel extends BaseContainerModel {
    bl_fi_comp_gendoc_flow_config: bl_fi_comp_gendoc_flow_config_RowInterface =
      new bl_fi_comp_gendoc_flow_config_RowClass();
  }
  